import { useRef, useCallback, useEffect } from 'react';
import { Input } from 'antd';

export interface SearchInputProps {
  onSearch: (keyword: string) => void;
  placeholder?: string;
  debounceMs?: number;
  allowClear?: boolean;
  style?: React.CSSProperties;
}

export function SearchInput({
  onSearch,
  placeholder,
  debounceMs = 300,
  allowClear = true,
  style,
}: SearchInputProps) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        onSearch(value);
      }, debounceMs);
    },
    [onSearch, debounceMs]
  );

  const handleSearch = useCallback(
    (value: string) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      onSearch(value);
    },
    [onSearch]
  );

  return (
    <Input.Search
      placeholder={placeholder}
      allowClear={allowClear}
      onChange={handleChange}
      onSearch={handleSearch}
      style={style}
    />
  );
}
